module.exports = __webpack_public_path__ + "static/img/shop_zf.jpg";